module.exports = __webpack_public_path__ + "static/lionmain-d3164791435819540ce685ad243537a0.png";